export const manifest = {
  screens: {
    scr_4qxup3: { name: "Format Select", route: "/", state: {"step":"format"}, position: {"x":8560,"y":220} },
    scr_7tstau: { name: "Language Select", route: "/", state: {"step":"language","lang":"en","format":"desktop"}, position: {"x":7160,"y":220} },
    scr_home: { name: "Intro", route: "/", state: {"step":"intro","lang":"en","format":"desktop"}, position: {"x":160,"y":220} },
    scr_1izw53: { name: "Video Tutorial", route: "/", state: {"step":"video","lang":"en","format":"desktop"}, position: {"x":1560,"y":220} },
    scr_up5ztf: { name: "Reminders", route: "/", state: {"step":"reminders","lang":"en","format":"desktop"}, position: {"x":4360,"y":220} },
    scr_z05z0k: { name: "Product Info", route: "/", state: {"step":"info","lang":"en","format":"desktop"}, position: {"x":2960,"y":220} },
    scr_eq5vmq: { name: "Goodbye", route: "/", state: {"step":"goodbye","lang":"en","format":"desktop"}, position: {"x":5760,"y":220} },
  },
  sections: {
    sec_i3ctnc: { name: "Onboarding flow", x: 0, y: 0, width: 9920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_i3ctnc", children: [
      { kind: "screen", id: "scr_home" },
      { kind: "screen", id: "scr_1izw53" },
      { kind: "screen", id: "scr_z05z0k" },
      { kind: "screen", id: "scr_up5ztf" },
      { kind: "screen", id: "scr_eq5vmq" },
      { kind: "screen", id: "scr_7tstau" },
      { kind: "screen", id: "scr_4qxup3" },
    ] },
  ],
}
